import { IonApp, IonButton, IonContent, IonSelect, IonSelectOption } from "@ionic/react";
import React, { Component } from "react";
import Toolbar from "../../components/Toolbar";
import "./style.css";
import Footer from "../../components/Footer";
import Firebase from "../../firebase";
import { Match } from "../../classes/Match";
import { getUserTournamentPlayoff } from "../../calcScore";

declare const document: any;

class Playoff extends Component {
  state = {
    fb: Firebase.getInstance(),
    data: {} as any,
    userPlayoffs: {} as any,
    teams: [],
    tournamentID: "",
    validForm: false,
  };

  currPlayoff: any = [];
  match: Match = null;

  async componentDidMount() {
    const data = await this.state.fb.readData("data");
    const userPlayoffs = await this.state.fb.readData("users/playoff/$uid");
    await this.setState({ data, userPlayoffs });

    document.getElementById("selectTournament").value = document.getElementsByClassName(
      "playoff__selectTournamentOption"
    )[0].value;
  }

  updateTournament = () => {
    this.currPlayoff = this.state.data.Playoff[this.state.tournamentID];
    if (!this.currPlayoff) this.state.teams = [];
    else {
      let teamIdx = 1;
      while ("team" + teamIdx in this.currPlayoff) {
        this.state.teams.push(this.state.data.Teams[this.currPlayoff["team" + teamIdx]]);
        teamIdx++;
      }
      this.match = new Match(this.state.teams, this.currPlayoff.numberOfGames.split(" ").reverse());
    }
    this.setState({});
  };

  checkInput = (target, match: Match) => {
    var val = target.value;
    var valNum: number = Number.parseInt(val);
    if (!/^\d*$/.test(val) || valNum < 0) {
      valNum = match.maxScore;
      target.value = valNum + "";
    }
    if (valNum > match.maxScore && match.level !== 0) {
      valNum = match.maxScore;
      target.value = valNum + "";
    }
    valNum = valNum || 0;
    return valNum;
  };

  checkValidity = (target, match: Match, idxChange) => {
    const inputs = document.getElementsByClassName("playoff__input");
    const nearInput = inputs[Object.values(inputs).indexOf(target) + idxChange];
    if (match.isValid) {
      target.classList.remove("playoff__inputError");
      nearInput.classList.remove("playoff__inputError");
    } else {
      target.classList.add("playoff__inputError");
      nearInput.classList.add("playoff__inputError");
    }

    this.forceUpdate();
  };

  updateChoice = (choice) => {
    choice.reverse().map((arr, level) => {
      this.match.fullLevel(level).map((match: Match) => {
        this.changeInput(document.getElementById("input1" + match.id), arr.shift());
        this.changeInput(document.getElementById("input2" + match.id), arr.shift());
      });
    });
  };

  changeInput = (input: HTMLInputElement, value) => {
    input.value = value + "";
    input.click();
  };

  renderTable = () => {
    const obj = [];
    const HEIGHT = this.match.height;
    const ROWS = Math.pow(2, HEIGHT);
    const matches: Match[][] = [];
    for (let i = HEIGHT; i >= 0; i--) matches.push(this.match.fullLevel(i));
    obj.push(
      <tr key={"trth"}>
        {Array.from(Array(HEIGHT + 1).keys()).map((i) => {
          return (
            <th key={"th" + i} className="playoff__th">
              שלב {i + 1}
              <br />
              הטוב מ-{matches[i][0].numberOfGames}
            </th>
          );
        })}
      </tr>
    );
    for (let row = 0; row < ROWS; row++) {
      obj.push(
        <tr key={"tr" + row}>
          {Array.from(Array(HEIGHT + 1).keys()).map((i) => {
            let rowspan = Math.pow(2, i);
            if ((ROWS - row) % rowspan === 0) {
              let match: Match = matches[i].shift();
              return (
                <td
                  key={"td" + match.id}
                  rowSpan={rowspan}
                  className={"playoff__td " + (matches[i].length % 2 === 1 ? "playoff__2n_td" : "")}
                >
                  <div className={"playoff__teamNameCol " + (match.winner === match.team1 ? "playoff__matchWin" : "")}>
                    {match.team1.teamName}
                  </div>
                  <input
                    id={"input1" + match.id}
                    className="playoff__input playoff__inputError"
                    type="text"
                    pattern="\d*"
                    inputMode="numeric"
                    onClick={(e) => {
                      match.score1 = this.checkInput(e.target, match);
                      this.checkValidity(e.target, match, 1);
                    }}
                    onChange={(e) => {
                      e.target.click();
                    }}
                  />
                  <br />
                  <div className={"playoff__teamNameCol " + (match.winner === match.team2 ? "playoff__matchWin" : "")}>
                    {match.team2.teamName}
                  </div>
                  <input
                    id={"input2" + match.id}
                    className="playoff__input playoff__inputError"
                    type="text"
                    pattern="\d*"
                    inputMode="numeric"
                    onClick={(e) => {
                      match.score2 = this.checkInput(e.target, match);
                      this.checkValidity(e.target, match, -1);
                    }}
                    onChange={(e) => {
                      e.target.click();
                    }}
                  />
                </td>
              );
            }
          })}
          {row === 0 && this.currPlayoff.trophyImage ? (
            <td rowSpan={ROWS}>
              <img src={this.currPlayoff.trophyImage} className="playoff__trophyImg" />
            </td>
          ) : (
            ""
          )}
        </tr>
      );
    }
    return obj;
  };

  render() {
    return (
      <IonApp>
        <Toolbar />
        <IonContent>
          <br />
          <IonSelect
            id="selectTournament"
            placeholder="בחירת טורניר"
            interface="popover"
            className="myteam__selectGame"
            onIonChange={(e: any) => {
              setTimeout(() => {
                this.setState({ tournamentID: e.detail.value });
                this.updateTournament();
                const lastSave = getUserTournamentPlayoff(this.state.userPlayoffs, this.state.tournamentID) || {};

                if (Object.keys(lastSave).length > 0) this.updateChoice(lastSave.choice);
              }, 0);
            }}
          >
            {this.state.data.Tournaments &&
              this.state.data.Tournaments?.map((tournamentValue: any, tournamentIndex: any) => {
                if (tournamentValue)
                  return (
                    <IonSelectOption
                      className="playoff__selectTournamentOption"
                      value={tournamentValue.tournamentID}
                      key={"tournament" + tournamentIndex}
                    >
                      {tournamentValue.tournamentDesc}
                    </IonSelectOption>
                  );
              })}
          </IonSelect>
          <br />
          {this.currPlayoff?.lastTimeToBet ? (
            <div style={{ textAlign: "center" }}>
              ניתן לשנות את הבחירה עד לתאריך {new Date(this.currPlayoff.lastTimeToBet).toLocaleDateString("he-IL")} בשעה{" "}
              {new Date(this.currPlayoff.lastTimeToBet).toLocaleTimeString("he-IL")}
            </div>
          ) : (
            <div />
          )}
          <br />
          {this.state.teams.length > 0 ? (
            <div>
              <div style={{ overflow: "auto" }}>
                <table className="playoff__table">
                  <tbody id="tbody">
                    {this.renderTable()}
                    {/* {[...(Array(this.match.height + 1).keys() as any)].reverse().map((level) => {
                                            return (
                                                <tr key={"tr" + level}>
                                                    {this.match.fullLevel(level).map((match: Match) => {
                                                        let colspan = Math.pow(2, match.height);
                                                        return [
                                                            <td key={"td" + match.id + "1"} colSpan={colspan} style={{ textAlign: "left" }}>
                                                                {match.team1.teamName}
                                                                <input
                                                                    className="playoff__input playoff__inputError"
                                                                    type="text"
                                                                    pattern="\d*"
                                                                    style={{ width: "40px" }}
                                                                    onClick={(e) => {
                                                                        match.score1 = this.checkInput(e.target, match);
                                                                        this.checkValidity(e.target, match, 1);
                                                                    }}
                                                                    onChange={(e) => {
                                                                        e.target.click();
                                                                    }}
                                                                />
                                                            </td>,
                                                            <td key={"td" + match.id + "2"} colSpan={colspan} style={{ textAlign: "right" }}>
                                                                <input
                                                                    className="playoff__input playoff__inputError"
                                                                    type="text"
                                                                    pattern="\d*"
                                                                    style={{ width: "40px" }}
                                                                    onClick={(e) => {
                                                                        match.score2 = this.checkInput(e.target, match);
                                                                        this.checkValidity(e.target, match, -1);
                                                                    }}
                                                                    onChange={(e) => {
                                                                        e.target.click();
                                                                    }}
                                                                />
                                                                {match.team2.teamName}
                                                            </td>,
                                                        ];
                                                    })}
                                                </tr>
                                            );
                                        })} */}
                  </tbody>
                </table>
                <br />
              </div>
              <br />
              <IonButton
                id="sendBtn"
                disabled={
                  !this.match.allMatches.reduce((acc, cur) => {
                    return acc && cur.isValid;
                  }, true)
                }
                style={{
                  display:
                    this.currPlayoff.firstTimeToBet > new Date() || this.currPlayoff.lastTimeToBet < new Date()
                      ? "none"
                      : "block",
                }}
                onClick={async () => {
                  const date = new Date();
                  const choice = [...(Array(this.match.height + 1).keys() as any)].reverse().map((level) => {
                    return this.match.fullLevel(level).reduce((acc, match: Match) => {
                      return acc.concat([match.score1, match.score2]);
                    }, []);
                  });
                  console.log(choice);

                  const res = await this.state.fb.setData("users/playoff/$uid/" + date.getTime(), {
                    time: date.getTime(),
                    choice,
                    tournamentID: this.state.tournamentID,
                  });
                  if (res.code === "PERMISSION_DENIED") {
                    alert(res.code);
                  } else {
                    await this.state.fb.analyticsEvent("save_playoff", {
                      tournamentID: this.state.tournamentID,
                    });
                  }
                  window.location.pathname = "/";
                }}
              >
                שמירה
              </IonButton>
            </div>
          ) : (
            ""
          )}

          <br />
          <Footer />
        </IonContent>
      </IonApp>
    );
  }
}

export default Playoff;
